export default __webpack_public_path__ + "static/media/parents_icon.853b9987.svg";